module.exports = __webpack_public_path__ + "static/media/hoi.6f0f32f1.svg";